<div class="custom-control custom-checkbox">
  <input id="checkbox-{{id}}" class="custom-control-input" name="{{name}}" type="checkbox" [checked]="checked" [disabled]="disabled" (click)="onChange($event)" />
  <label for="checkbox-{{id}}" class="custom-control-label">{{label}}</label>
</div>
